import {
  Form, Space, Row, Col, Input, InputNumber,
} from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { any } from 'prop-types';
import Decimal from 'decimal.js'; // 导入 decimal.js
import { addDecimalNum, moneyDelete } from '@/utils/utils';

const min = 0;
const max = 999999999;

export default function EquipmentList({ form, rowKey, parentForm }) {
  const calcCompleted = (index) => {
    if (parentForm && rowKey) {
      const finishFlagList = parentForm.getFieldValue(`specialAgriculturalFundsEquips${rowKey}`) || [];
      const currentFinishFlag = finishFlagList[index];
      if (!currentFinishFlag) return;

      if (currentFinishFlag.finishFlag) {
        const list = form.getFieldValue('specialAgriculturalFundsEquips') || [];
        const current = list[index];
        const total = addDecimalNum([current.provincialSubsidyFunds, current.cityFunding, current.selfFunding, current.otherFunding]);
        form.setFieldValue(
          ['specialAgriculturalFundsEquips', index, 'equipmentInvestmentCompleted'],
          total,
        );
      }
    }
  };
    // 计算总额的公共方法
  const calculateTotalAmount = (price, quantity) => {
    if (price === undefined || quantity === undefined || price === null || quantity === null) {
      return undefined;
    }
    try {
      const decimalPrice = new Decimal(price);
      const decimalQuantity = new Decimal(quantity);
      const total = decimalPrice.times(decimalQuantity);
      return total.toNumber();
    } catch (error) {
      console.error('计算总额出错:', error);
      return undefined;
    }
  };

  return (
    <Form.List name="specialAgriculturalFundsEquips">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => {
            const isLast = index === fields.length - 1;
            const onlyOne = fields.length === 1;

            return (
              <div
                key={field.key}
                style={{ border: '1px solid #ccc', padding: '10px 10px 0 10px', marginBottom: '16px' }}
              >
                {/* 设备表单行 */}
                <Row>
                  <Col span={6}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'equipName']}
                      label="设施设备名称"
                      rules={[{ required: true, message: '请输入设施设备名称' }]}
                    >
                      <Input placeholder="请输入设施设备名称" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'unit']}
                      label="单位"
                      rules={[{ required: true, message: '请输入单位' }]}
                    >
                      <Input placeholder="请输入单位" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'equipType']}
                      label="设备型号"
                    >
                      <Input placeholder="请输入设备型号" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'unitPrice']}
                      label="单价"
                      rules={[{ required: true, message: '请输入单价' }]}
                    >
                      <InputNumber
                        placeholder="请输入单价"
                        addonAfter="万元"
                        min={min}
                        max={max}
                        style={{ width: '100%' }}
                        onChange={(val) => {
                          const price = moneyDelete(val);
                          const num = moneyDelete(form.getFieldValue(['specialAgriculturalFundsEquips', field.name, 'num']));
                          const totalAmount = calculateTotalAmount(price, num);
                          form.setFieldValue(
                            ['specialAgriculturalFundsEquips', field.name, 'totalAmount'],
                            totalAmount,
                          );
                          form.validateFields([['specialAgriculturalFundsEquips', index, 'totalAmount']]);
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'num']}
                      label="数量"
                      rules={[{ required: true, message: '请输入数量' }]}
                    >
                      <InputNumber
                        placeholder="请输入数量"
                        min={min}
                        max={max}
                        style={{ width: '100%' }}
                        onChange={(val) => {
                          const price = moneyDelete(
                            form.getFieldValue(['specialAgriculturalFundsEquips', field.name, 'unitPrice']),
                          );
                          const totalAmount = calculateTotalAmount(price, moneyDelete(val));

                          form.setFieldValue(
                            ['specialAgriculturalFundsEquips', field.name, 'totalAmount'],
                            totalAmount,
                          );
                          form.validateFields([['specialAgriculturalFundsEquips', index, 'totalAmount']]);
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'totalAmount']}
                      label="总额"
                      rules={[
                        {
                          validator: (_, val) => (moneyDelete(val) >= 0 ? Promise.resolve() : Promise.reject(new Error('总额必须大于等于0'))),
                        },
                      ]}
                    >
                      <InputNumber addonAfter="万元" disabled style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name={[field.name, 'provincialSubsidyFunds']}
                      label="省级专项资金"
                      rules={[
                        {
                          required: true,
                          message: '请输入省级专项资金',
                        },
                      ]}
                    >
                      <InputNumber
                        placeholder="请输入省级专项资金"
                        style={{ width: '100%' }}
                        addonAfter="万元"
                        min={min}
                        max={max}
                        onChange={() => calcCompleted(index)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name={[field.name, 'cityFunding']}
                      label="市县资金"
                      rules={[
                        { required: true, message: '请输入市县资金' },
                      ]}
                    >
                      <InputNumber
                        placeholder="请输入市县资金"
                        style={{ width: '100%' }}
                        addonAfter="万元"
                        min={min}
                        max={max}
                        onChange={() => calcCompleted(index)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name={[field.name, 'selfFunding']}
                      label="企业自筹资金"
                      rules={[
                        {
                          required: true,
                          message: '请输入企业自筹资金',
                        },
                      ]}
                    >
                      <InputNumber
                        addonAfter="万元"
                        placeholder="请输入企业自筹资金"
                        style={{ width: '100%' }}
                        min={min}
                        max={max}
                        onChange={() => calcCompleted(index)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name={[field.name, 'otherFunding']}
                      label="其他资金"
                      rules={[
                        {
                          required: true,
                          message: '请输入其他资金',
                        },
                      ]}
                    >
                      <InputNumber
                        addonAfter="万元"
                        min={min}
                        max={max}
                        placeholder="请输入其他资金"
                        style={{ width: '100%' }}
                        onChange={() => calcCompleted(index)}
                      />
                    </Form.Item>
                  </Col>
                  {
                    rowKey && (
                      <Col span={6} hidden>
                        <Form.Item
                          name={[field.name, 'equipmentInvestmentCompleted']}
                          label="已完成投资"
                        >
                          <InputNumber />
                        </Form.Item>
                      </Col>
                    )
                  }
                  <Col span={6}>
                    <Space style={{ margin: '6px 0 0 50px' }}>
                      {
                        isLast && <PlusCircleOutlined style={{ color: '#12A366', fontSize: 20 }} onClick={() => add()} />
                      }
                      {
                        !onlyOne && (
                          <MinusCircleOutlined
                            style={{ color: 'red', fontSize: 20 }}
                            onClick={() => {
                              remove(field.name);
                              if (rowKey) {
                                const listName = `specialAgriculturalFundsEquips${rowKey}`;
                                const finishFlagList = parentForm.getFieldValue(listName) || [];
                                const newArr = finishFlagList?.filter((_, i) => i !== field.name);
                                parentForm.setFieldsValue({
                                  [listName]: newArr,
                                });
                              }
                            }}
                          />
                        )
                      }
                    </Space>
                  </Col>
                </Row>
              </div>
            );
          })}
        </>
      )}
    </Form.List>
  );
}
EquipmentList.propTypes = {
  form: any,
  rowKey: any,
  parentForm: any,
};
